<template>
	<div class="tv-otp-input">
		<p class="body-4">{{ label }}</p>
		<!-- otp input -->
		<div class="tv-otp-input__content">
			<input
				v-for="(digit, index) in digits"
				:key="index"
				class="digit-box"
				v-model="digits[index]"
				@input="handleInputChange(index, $event)"
				@keydown="handleDelete(index, $event)"
				:maxlength="1"
				:class="{ error: isInvalid }"
				style="color: #15202a"
				type="number"
				@paste="handlePaste($event)"
			/>
		</div>
		<!-- helper text -->
		<p v-if="!isInvalid" class="caption">
			{{ helperText }}
		</p>
		<!-- error text -->
		<p v-if="isInvalid" class="caption error-msg">
			<span class="material-symbols-outlined" translate="no"> error </span>
			{{ invalidText }}
		</p>
	</div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'

const props = defineProps({
	otpValue: String,
	resetOtp: Boolean, // Nueva prop para detectar reinicios
	isInvalid: Boolean,
	label: {
		type: String,
		default: '',
	},
	helperText: {
		type: String,
		default: '',
	},
	invalidText: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['otp-entered'])
const digits = ref(Array(6).fill(''))

// Observa cambios en otpValue para actualizar los dígitos
watch(
	() => props.otpValue,
	(newOtpValue) => {
		if (!newOtpValue) {
			digits.value = Array(6).fill('')
		} else {
			for (let i = 0; i < newOtpValue.length && i < 6; i++) {
				digits.value[i] = newOtpValue[i]
			}
		}
	},
)

// Observa cambios en resetOtp para limpiar los campos
watch(
	() => props.resetOtp,
	(newReset) => {
		if (newReset) {
			clearOtp()
		}
	},
)

const handleInputChange = (index, event) => {
	const input = event.target
	if (input.value.length > 1) {
		digits.value[index] = input.value[input.value.length - 1]
	} else {
		digits.value[index] = input.value
	}
	if (index < digits.value.length - 1 && input.value) {
		input.nextElementSibling.focus()
	}
	const otpCode = digits.value.join('')
	emit('otp-entered', otpCode)
}

const handleDelete = (index, event) => {
	if (event.key === 'Backspace' && index > 0 && !digits.value[index]) {
		digits.value[index - 1] = ''
		document.querySelector(`.digit-box:nth-child(${index})`).focus()
	}
}

// Método para limpiar OTP
const clearOtp = () => {
	digits.value = Array(6).fill('')
	emit('otp-entered', '') // Notifica al padre que se ha limpiado el OTP
}

const handlePaste = (event) => {
	event.preventDefault()
	const pastedData = (event.clipboardData || window.clipboardData).getData(
		'text',
	)
	if (/^\d{6}$/.test(pastedData)) {
		digits.value = pastedData.split('')
		const otpCode = digits.value.join('')
		emit('otp-entered', otpCode)
	}
}
</script>

<style lang="scss" scoped>
.otp-input {
	.caption.error-msg {
		.material-symbols-outlined {
			color: #eb0000 !important;
			font-size: 0.75rem !important;
		}
	}
}
</style>
